import React from "react";

const Badge = ({ variant, children }) => {
  let color;

  if (variant === "success") {
    color = "bg-green-100 text-green-600";
  } else if (variant === "default") {
    color = "bg-gray-700 text-gray-100";
  } else if (variant === "danger") {
    color = "bg-red-100 text-red-600";
  } else {
    color = "bg-blue-100 text-blue-600";
  }

  return (
    <div className="m-1.5 text-center">
      <div
        className={`inline-flex text-2xs font-medium md:text-xs ${color} rounded-full px-2.5 py-1 text-center`}
      >
        {children}
      </div>
    </div>
  );
};

export default Badge;
